/**
 * TypingIndicator — shows a 3-dot bouncing animation while the agent is typing.
 *
 * Accessibility:
 * - Rendered outside the aria-live="polite" log so it does NOT spam screen readers.
 * - Has its own aria-label for assistive tech but is NOT in a live region.
 * - Respects prefers-reduced-motion: dots freeze when motion is reduced.
 */
export function TypingIndicator() {
  return (
    <div
      class="flex justify-start px-3 mb-1.5"
      aria-label="Agent is typing"
      aria-live="off"
    >
      <div class="flex items-center gap-1 px-3 py-2.5 bg-w-bb-bg rounded-[7.5px] rounded-tl-sm shadow-chat-bubble">
        <span class="w-2 h-2 rounded-full bg-w-secondary/60 animate-typing-dot [animation-delay:0ms]" />
        <span class="w-2 h-2 rounded-full bg-w-secondary/60 animate-typing-dot [animation-delay:160ms]" />
        <span class="w-2 h-2 rounded-full bg-w-secondary/60 animate-typing-dot [animation-delay:320ms]" />
      </div>
    </div>
  );
}
